import React, { useState }  from 'react';
import { getString } from '../../../app-content';
import { Button, Image } from '@nackle/paper';
import chromePin from '../../../assets/chrome-pin.png';
import logo from '../../../assets/rn-logo-300.png';

export default function ChromeLinkView( props ) {
    const [ chromeConnected, setChromeConnected ] = useState( false );
    return ( 
        <div style={ { padding: '20px' } }>
            <div style={ { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: '36px' } }>
                <Image alt='' preview={ false } src={ logo } width='100px'/>
                <h1 style={ { width: '300px', textAlign: 'center', paddingTop: '16px' } }>
                    { chromeConnected 
                        ? 
                            getString( 'teams.webView.chrome.authorize.connectedHeader' )
                        :
                            getString( 'teams.webView.chrome.authorize' ) }
                </h1>
                { chromeConnected &&
                    <div style={ { padding: '16px', textAlign: 'center', fontSize: '16px' } }>
                        { getString( 'teams.webView.chrome.authorize.connectedBody' ) }
                    </div>
                }
            </div>
            <div style={ { display: 'flex', flexDirection: 'column',  alignItems: 'center', justifyContent: 'center' } }>
                <div style={ { display: chromeConnected ? 'flex' : 'none', 
                    flexDirection: 'column', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    borderStyle: 'solid', 
                    borderWidth: 1,
                    borderColor: '#C9C7C6',
                    padding: '10px 50px' 
                        } }>
                    <Image
                        preview={ false } width="200" src={ chromePin } alt=''/>
                        <div>
                            Pin it to your toolbar for quick access!
                        </div>
                </div>
                <Button
                    id='linkToChrome'
                    className='primary-button-background'
                    style={ { margin: '5px', color: 'white', width: '300px', display: chromeConnected ? 'none' : 'block' } }
                    onClick={ () => setChromeConnected( true ) }
                >
                    { getString( 'teams.webView.chrome.authorize.continue' ) }
                </Button>
                <a href="#"
                    id='cancelLinkToChrome'
                    onClick={ () => {
                        window.open( 'about:blank', '_self' );
                        window.close();
                    } }
                    style={ { margin: '5px', padding: '10px' } }>
                    { chromeConnected ?  getString( 'teams.webView.chrome.authorize.close' ) : getString( 'teams.webView.chrome.authorize.cancel' ) }
                </a>
            </div>
        </div>
    );
}
